export const CellItemHeight = {
  Large: 'Large',
  Small: 'Small',
};

export const ViewItem = {
  Monthly: 'Monthly',
  Daily: 'Daily',
};

export const ViewItemTLString = {
  [ViewItem.Monthly]: _TL_('Monthly view'),
  [ViewItem.Daily]: _TL_('Daily view'),
};

export const InsertionOrderReportColumns = {
  [ViewItem.Monthly]: {
    add: ['IOReportMonth'],
    remove: ['Date'],
    sort: 'IOReportMonth',
  },
  [ViewItem.Daily]: {
    add: ['Date'],
    remove: ['IOReportMonth'],
    sort: 'Date',
  },
};

export const MaxInsertionOrderLimit = 100;

export const InsertionOrderSearchFields = {
  FriendlyName: 'FriendlyName',
  SeriesName: 'SeriesName',
};

export const InsertionOrderFieldKeys = {
  [InsertionOrderSearchFields.FriendlyName]: _TL_('Insertion order name'),
  [InsertionOrderSearchFields.SeriesName]: _TL_('Series name'),
};

export const MismatchedReasonCode = {
  AdjustmentMismatch: 'Adjustment mismatch',
};

export const ChangeTypeEnum = {
  Spend: 'Spend',
  SystemAdjustment: 'System adjustment',
  BudgetChange: 'Budget change',
};

export const InsertionOrderChangeTypeField = {
  [ChangeTypeEnum.Spend]: 'SpendTypeValue',
  [ChangeTypeEnum.SystemAdjustment]: 'AdjustmentTypeValue',
  [ChangeTypeEnum.BudgetChange]: 'BudgetChangedTypeValue',
};

export const InsertionOrderChangeAmountField = {
  [ChangeTypeEnum.Spend]: 'SpendAmountValue',
  [ChangeTypeEnum.SystemAdjustment]: 'AdjustmentAmountValue',
  [ChangeTypeEnum.BudgetChange]: 'BudgetChangedAmountValue',
};

export const InsertionOrderColumns = {
  InsertionOrderId: 'InsertionOrderId',
};

export const ChangeTypeEnumValue = {
  [ChangeTypeEnum.Spend]: "Enum.ChangeType'1'",
  [ChangeTypeEnum.SystemAdjustment]: "Enum.ChangeType'2'",
  [ChangeTypeEnum.BudgetChange]: "Enum.ChangeType'3'",
};
